module.exports = __webpack_public_path__ + "img/pd_T4.2.8f9b3b67.png";